export default {
  en: {
    translation: {
      queue: {
        title: 'Upload Queue',
        title_uploading_with_counter: 'Uploading {{num}} assets',
        title_processing_with_counter: 'Processing {{num}} assets',
        title_uploading_processing_with_counters: 'Uploading {{uploading}} assets, processing {{processing}} assets',
        title_uploading: 'Uploading assets',
        mini_title: 'Uploaded',
        mini_title_uploading: 'Uploading',
        mini_title_processing: 'Processing',
        show_completed: 'Show completed',
        retry_failed: 'Retry failed',
        abort_all: 'Abort all',
        upload_more: 'Upload more',
        done: 'Done',

        mini_upload_count: '{{num}} uploaded',
        mini_failed: '{{num}} failed',

        statuses: {
          uploading: 'Uploading...',
          processing: 'Processing...',
          timeout: 'A large file is currently being uploaded. It might take a while to appear in your product environment.',
          error: 'Error',
          uploaded: 'Done',
          aborted: 'Aborted',
        },
      },
    },
  },
};
